// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3mvGS","rightAdornment":"Header_rightAdornment__30YRb"};